import styled, { css } from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Tab = {
    Area: styled.div`
        cursor: default;
        height: 100%;
        border-radius: 8px 8px 0px 0px;
        ${FlexCentered}
        justify-content: space-evenly;
        margin: 0px 5px;
        padding: 0px 10px;
        ${({ isActive }) => {
            const bgColor = isActive ? '#191B1E' : 'transparent'
            const opacity = isActive ? 1 : 0.5

            return css`
                background-color: ${bgColor};
                opacity: ${opacity};
            `
        }}
        & > div {
            margin: 0px 2.5px;
        }
    `,
    Icon: styled.div``,
    Title: styled.div``,
}
